import React, { useEffect } from "react";
import SubHeader from "../../components/header/SubHeader";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchOrders,
    resetCreateStatus, resetFetchCustomerStatus,
    resetUpdatePaymentStatus,
    resetUpdateStatus,
    updateOrderPayment,
    fetchOrdersByFilter
} from "../../store/order-slice";
import { Role } from "../../enums/enums";
import ActionButton from "../../components/actions/ActionButton";
import { orderSchema } from "../../schema/orderSchema";
import { getFormData } from "../../models/orderModel";

import FilterOrders from "../../components/order/FilterOrders";
import OrderList from "../../components/order/OrderList";

const TrackOrder = () => {
    const dispatch = useDispatch();

    const userRole = useSelector((state) => state.auth.selectedRole);

    const timezone = 'Asia/Kolkata';

    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        fetchCustomerStatus,
        updatePaymentStatus,
        error
    } = useSelector((state) => state.order);

    useEffect(() => {
        dispatch(fetchOrders(userRole));
    }, [dispatch, userRole]);

    useEffect(() => {
        if (updatePaymentStatus === "success") {
            dispatch(fetchOrders(userRole));
        }
    }, [dispatch, userRole, updatePaymentStatus]);

    useEffect(() => {
        if (createStatus === "success" || updateStatus === "success" || updatePaymentStatus === "success" || fetchCustomerStatus === "success") {
            dispatch(resetCreateStatus());
            dispatch(resetUpdatePaymentStatus());
            dispatch(resetUpdateStatus());
            dispatch(resetFetchCustomerStatus());
        }
    }, [dispatch, createStatus, updateStatus, updatePaymentStatus, fetchCustomerStatus]);

    const updateOrderHandler = (data) => {
        const updateOrderData = {
            ...data,
            orderStatus: +data.orderStatus,
            paymentStatus: +data.paymentStatus,
        }
        dispatch(updateOrderPayment({
            ...userRole,
            data: updateOrderData
        }));
    }

    const schema = orderSchema();
    delete schema.paymentType

    const formData = {
        schema: schema,
        data: getFormData(),
        status: updatePaymentStatus,
        error: error
    }

    return (
        <>
            <SubHeader title="Orders">
                <ActionButton
                    permissions={['BranchAdmin', 'BranchOwner', 'BranchManager']}
                    to="add"
                    className="btn-sm bg-primary bg-opacity-50">Add New</ActionButton>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}

            <div className="container m-0 p-0">
                {userRole.role !== Role.Employee && <FilterOrders fetchOrders={fetchOrders} fetchOrdersByFilter={fetchOrdersByFilter} />}
                <div className="row">
                    <div className="col-12">
                        {fetchStatus === "success" && <OrderList
                            items={items.filter(item => item.orderStatus !== 3)}
                            userRole={userRole}
                            timezone={timezone}
                            formData={formData}
                            onOrderUpdate={updateOrderHandler}
                        />}
                    </div>
                </div>
            </div>

        </>
    );
}
export default TrackOrder;

